import React from "react";
import Modal from "../../elements/Modal";
import MultiselectDropdown from "../../elements/MultiselectDropdown";
import styles from "../AddReportPopup/index.module.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeEdit } from "../../../store/slices/addReport/popup.slice";
import {
  asyncThunkUpdateFnbReport,
  updateReport,
} from "../../../store/slices/addReport/yourReports.slice";
import { terminalSteps } from "../../../utils/constant";

const EditReport = () => {
  const dispatch = useDispatch();
  const { yourReports } = useSelector((store) => store.yourReports); // List of your stories.
  const { showEditReport } = useSelector((store) => store.addReport); // hide/show edit popup.
  const {
    data: { store:storeSteps },
    loading
  } = useSelector((store) => store.fnbConstants);

  const [selectedTerminal, setSelectedTerminal] = useState(
    yourReports[showEditReport.reportIndex].terminal.split("|")
  );
  const [selectedStore, setSelectedStore] = useState(
    yourReports[showEditReport.reportIndex].store.split("|")
  );
  const [selectedBreakup, setSelectedBreakup] = useState(
    yourReports[showEditReport.reportIndex].breakup
      ? yourReports[showEditReport.reportIndex].breakup.split("|")
      : []
  );
  const [reportName, setReportName] = useState(
    yourReports[showEditReport.reportIndex].name
  );

  // Manage terminal selection.
  const onSelectedTerminalsChange = (value) => {
    setSelectedTerminal(value);
  };

  // Mange store selection.
  const onSelectedStoreChange = (value) => {
    setSelectedStore(value);
  };

  // Manage breakup selection.
  const onSelectedBreakupChange = (value) => {
    setSelectedBreakup(value);
  };

  // Handles title input
  const onChangeTitle = (e) => {
    setReportName(e.target.value);
  };

  // Handle cancel button.
  const showAddReport = () =>
    dispatch(closeEdit({ show: false, reportIndex: -1 }));

  // Handle update.
  const onUpdate = () => {
    let err = 0;
    if (reportName.length == 0) {
      err++;
      alert("Name field is requied!");
    } else if (selectedTerminal.length == 0) {
      err++;
      alert("Select atleast one terminal!");
    } else if (selectedStore.length == 0) {
      err++;
      alert("Select atleast one store!");
    } else if (selectedBreakup.length < 2) {
      err++;
      alert("Select atleast 2 comparisons!");
    }

    if (err == 0) {
      dispatch(
        asyncThunkUpdateFnbReport({
          id: yourReports[showEditReport.reportIndex].id,
          name: reportName,
          terminal: selectedTerminal.join("|"),
          store: selectedStore.join("|"),
          breakup: selectedBreakup.join("|"),
        })
      );
      showAddReport();
    }
  };
  return (
    <Modal>
      <div className={styles["content"]}>
        {/* Heading */}
        <div className={styles["heading"]}>
          <h3>Create report</h3>
          <p>Create your customized reports</p>
        </div>

        {/* Name input */}
        <div className={styles["nameInput"]}>
          <label htmlFor="">Name</label>
          <input
            type="text"
            placeholder="List of products in Landside"
            value={reportName}
            onChange={onChangeTitle}
          />
        </div>

        {/* Terminal and store selection. */}
        <div className={styles["terminalStore"]}>
          <div className={styles["dropdown"]}>
            <div className={styles["title"]}>
              <span>Terminal</span>
              <i class="bi bi-columns-gap"></i>
            </div>
            <MultiselectDropdown
              steps={terminalSteps}
              selSteps={yourReports[showEditReport.reportIndex].terminal.split(
                "|"
              )}
              name=""
              onChange={onSelectedTerminalsChange}
            />
          </div>
          <div className={styles["dropdown"]}>
            <div className={styles["title"]}>
              <span>Stores</span>
              <i class="bi bi-tag"></i>
            </div>

            <MultiselectDropdown
              steps={storeSteps}
              selSteps={yourReports[showEditReport.reportIndex].store.split(
                "|"
              )}
              name=""
              onChange={onSelectedStoreChange}
            />
          </div>
          <div className={styles["dropdown"]}>
            <div className={styles["title"]}>
              <span>Comparisons</span>
              <i class="bi bi-list"></i>
            </div>
            <MultiselectDropdown
              steps={storeSteps}
              selSteps={selectedBreakup}
              name=""
              onChange={onSelectedBreakupChange}
            />
          </div>
        </div>

        {/* Create and cancel button. */}
        <div className={styles["createCancel"]}>
          <div className={styles["create"]} onClick={onUpdate}>
            Update
          </div>
          <div className={styles["cancel"]} onClick={showAddReport}>
            Cancel
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditReport;
